export const form = {
  headerTitle: 'SEJA UM REVENDEDOR RIFFEL',
  headerTitleResult: 'Cadastro Recebido',
  formTitle: 'Preencha as informações abaixo para podemos te atender',
  resultTitle: 'Abaixo estão as informações dos nossos distribuidores',
  name: 'Razão Social',
  name_placeholder: 'Digite a razão social',
  cnpj: 'CNPJ',
  cnpj_placeholder: 'Digite O CNPJ',
  invalid_feedback_cnpj: 'CNPJ Inválido',
  responsible: 'Responsável',
  responsible_placeholder: 'Digite o nome do responsável da empresa',
  segments: 'Qual o segmento? (selecione mais de um se necessário)',
  products: 'Qual o produto de interesse? (selecione mais de um se necessário)',
  kits: 'Quantos Kits transmissão/tração você vende por mês?',
  services:
    'Como você prefere ser atendido? (selecione mais de um se necessário)',
  email: 'E-mail',
  email_placeholder: 'Digite seu e-mail',
  phone: 'WhatsApp',
  phone_placeholder: 'Digite seu numero de WhatsApp',
  state: 'Estado',
  city: 'Cidade',
  city_placeholder: 'Digite a cidade',
  zipcode: 'CEP',
  zipcode_placeholder: 'Digite o CEP',
  uf: 'UF',
  invalid_feedback: '*Campo Obrigatório',
  button: ' Enviar informações',
};

export const result = {};
